class CustomMegaMenu extends HTMLElement {
  constructor() {
    super();

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleNavigationMouseOver = this.handleNavigationMouseOver.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('.custom-mega-menu__trigger');
    this.navigation = this.closest('.header__inline-menu');

    if (!this.trigger) return;

    this.trigger.setAttribute('aria-expanded', 'false');
    this.addEventListener('mouseenter', this.open);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    this.addEventListener('focusin', this.open);
    this.addEventListener('focusout', this.handleFocusOut);
    this.addEventListener('keyup', this.handleKeyUp);

    if (this.navigation) {
      this.navigation.addEventListener('mouseover', this.handleNavigationMouseOver);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.open);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
    this.removeEventListener('focusin', this.open);
    this.removeEventListener('focusout', this.handleFocusOut);
    this.removeEventListener('keyup', this.handleKeyUp);

    if (this.navigation) {
      this.navigation.removeEventListener('mouseover', this.handleNavigationMouseOver);
    }
  }

  open() {
    window.clearTimeout(this.closeTimer);
    CustomMegaMenu.closeAll(this);
    this.setAttribute('open', '');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    window.clearTimeout(this.closeTimer);
    this.removeAttribute('open');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  handleMouseLeave() {
    this.closeTimer = window.setTimeout(() => {
      if (!this.matches(':hover') && !this.contains(document.activeElement)) {
        this.close();
      }
    }, 120);
  }

  handleFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  handleKeyUp(event) {
    if (event.code !== 'Escape') return;

    this.close();
    this.trigger.focus();
  }

  handleNavigationMouseOver(event) {
    const menuItem = event.target.closest('.header__inline-menu > ul > li');

    if (menuItem && !menuItem.contains(this)) {
      this.close();
    }
  }

  static closeAll(currentMenu = null) {
    for (const menu of document.querySelectorAll('custom-mega-menu[open]')) {
      if (menu !== currentMenu) {
        menu.close();
      }
    }

    for (const details of document.querySelectorAll('header-menu details[open]')) {
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }
  }
}

if (!customElements.get('custom-mega-menu')) {
  customElements.define('custom-mega-menu', CustomMegaMenu);
}
